export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5660.3c3c885c.jpg";